import $ from 'jquery';

const main = () => {
  $(document).ready(function() {
    // estate_type の数値に応じたグループ名を返す関数
    function getGroupNames(estateType) {
        if (estateType === '1' || estateType === '99') {
            // 戸建て・その他の場合は、building と land の両方を適用
            return ['building', 'land'];
        } else if (estateType === '2') {
            // 土地の場合
            return ['land'];
        } else if (estateType === '3') {
            // マンションの場合
            return ['mansion'];
        }
        return [];
    }

    function updateFields() {
        var selectedType = $('input[name="estate_type"]:checked').val();
        var groupsToShow = getGroupNames(selectedType);

        // 全行をいったん非表示にする（data-estate-types を設定している行だけ対象）
        $('[data-estate-types]').hide();

        // 各行について、data-estate-types 属性に定義されたグループのうち、どれかが選択グループに含まれていれば表示する
        $('[data-estate-types]').each(function() {
            var types = $(this).data('estate-types'); // 例: "building,land"
            if (types) {
                // カンマ区切りのリストに変換
                var typeList = types.split(',').map(function(item) {
                    return item.trim();
                });
                // 選択されたグループと一つでもマッチすれば表示
                var show = groupsToShow.some(function(group) {
                    return typeList.indexOf(group) !== -1;
                });
                if(show) {
                    $(this).show();
                }
            }
        });
    }

    // estate_type の変更イベントにバインド
    $('input[name="estate_type"]').on('change', updateFields);
    // 初期表示時にも実行
    updateFields();
});
}

export default main;